import styled from 'styled-components'
import Outline24DownArrow from '@mds/mds-icons/icons/svg/outline-24-down-arrow.svg';

const Wrapper = styled.div`
    display : flex;
    gap : clamp(4px, 0.5vw, 10px);
    align-items : center;
    border : solid thin #ccc;
    padding : 0 clamp(6px, 0.8vw, 16px);
    height : 40px;
    box-sizing : border-box;
    cursor : pointer;
    font-size : clamp(11px, 1.1vw, 14px);
    overflow : hidden;
    &:hover,&.active{
        border : solid thin #2251ff;
        color : #2251cc;
    }
    .mds-check {
        margin : 0;
    }
    .spacer {
        flex : 1;
    }
    p {
        margin : 0 !important;
        overflow : hidden;
        text-overflow : ellipsis;
        white-space : nowrap;
        max-width : 100%;
    }
    input.clear {
        background : none;
        color : #6c6c6c;
        border : none;
    }
    input.chevron{
        border : none;
        width : 24px;
        height : 24px;
        background : url('${Outline24DownArrow}') no-repeat center;
        background-size : 16px;
        &.open{
            transform : rotateX(180deg)
        }
    }

    position : relative;
    .popup{
        position : absolute;
        max-height : 350px;
        display : flex;
        flex-direction : column;
        width : 240px;
        left : -1px;
        overflow-y : auto;
        overflow-x : hidden;
        top : 100%;
        border : solid thin #ccc;
        background : #fff;
        z-index : 1;
        .status{
            font-size : 14px;
            color : #000;
            padding : 5px 10px;
            background : #f2f2f2;
        }
        input{
            background : #fff;
            box-sizing : border-box;
            margin : 10px;
            border-radius : 3px;
            padding : 10px;
            display : block;
            outline : none;
            font-size : 1rem;
            border : solid thin #ccc;
        }
        .show-selected{
            padding : 5px 10px;
            color : #2251ff;
            cursor : pointer;
            text-align : right;
            &:hover{
                text-decoration : underline;
            }
        }
        .popup-items{
            flex : 1;
            overflow-y : auto;
            overflow-x : hidden;
            .collapsiable-checkbox{
                width : 100%;
            }
        }
        .popup-item{
            display : flex;
            flex-wrap : wrap;
            align-items : center;
            box-sizing : border-box;

            .collapsiable-checkbox{
                .parent{
                    display : flex;
                    align-items : center;
                    justify-content : space-between;
                    svg{
                        cursor : pointer;
                        padding : 50px;
                        min-width : 16px;
                        transition : 0.4s;
                        &.open{
                            transform : rotateX(180deg)
                        }
                    }
                }
                .children {
                    padding-left : 10px;
                    box-sizing : border-box;
                    transition : 0.4s;
                    &.close{
                        height : 0;
                        overflow : hidden;
                    }
                }
            }

            label{
                padding: 10px;
                word-break : break-all;
                gap: 10px;
                box-sizing: border-box;
                >div{
                    min-width : 20px;
                }
            }
        }
    }
`

export default Wrapper